import { render, staticRenderFns } from "./OutsourcingEditCompanyPage.vue?vue&type=template&id=0ccfef0b&"
import script from "./OutsourcingEditCompanyPage.vue?vue&type=script&lang=js&"
export * from "./OutsourcingEditCompanyPage.vue?vue&type=script&lang=js&"
import style0 from "./OutsourcingEditCompanyPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports